/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppLinkProductsMutationVariables = Types.Exact<{
  input: Types.IAppLinkProductsInput;
}>;

export type IAppLinkProductsMutation = {
  __typename?: 'Mutation';
  appLinkProducts?: {
    __typename?: 'AppLinkProductsPayload';
    errors?: Array<string> | null;
    success: boolean;
    app?: {
      __typename?: 'App';
      id: string;
      name?: string | null;
      criticality?: Types.AppCriticalityEnum | null;
      unclaimed: boolean;
      owned: boolean;
      ownerName: string;
      logoUrl?: string | null;
      taskCounts: Array<{ __typename?: 'TaskCount'; criticality: Types.TaskCriticalityEnum; count: number }>;
      policy: { __typename?: 'AppPolicy'; update: boolean; remove: boolean };
    } | null;
  } | null;
};

export const AppLinkProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'appLinkProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppLinkProductsInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appLinkProducts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'app' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppBaseFields' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppBaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'App' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unclaimed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppLinkProductsMutation, IAppLinkProductsMutationVariables>;
